export default "__VITE_ASSET__BFHb$Elw__"